import React from 'react'
import { generatePath, Link } from 'react-router-dom'
import { Button, Space, Input } from 'antd'
import * as Icons from '@ant-design/icons'
import { useQueryParam, StringParam } from 'use-query-params'

import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb } from 'admin/lib/Breadcrumbs'
import * as ROUTES from 'admin/routes'

import { PublicApiKeysList } from './PublicApiKeysList'

export function PublicApiKeys() {
  const [searchTerm, setSearchTerm] = useQueryParam('search', StringParam)

  return (
    <Layout
      header={
        <>
          <Breadcrumb
            items={[
              {
                title: 'Public API Keys'
              }
            ]}
          />

          <Space>
            <Input.Search
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value, 'replace')}
              style={{ maxWidth: '20rem' }}
            />

            <Link
              to={generatePath(ROUTES.PUBLIC_API_KEYS.EDIT, {
                apiKeyId: 'register'
              })}
            >
              <Button type="primary" icon={<Icons.FolderAddOutlined />}>
                New
              </Button>
            </Link>
          </Space>
        </>
      }
    >
      <PublicApiKeysList searchTerm={searchTerm} />
    </Layout>
  )
}
